import axios from "axios";
import { useCallback, useState } from "react";
import { URL } from "../../config";
import { useDispatch, useSelector } from "react-redux";
import { setErrorMessage, setSuccessMessage } from "../slices/MessageSlice";

const CheckCoupon = () => {
    const dispatch=useDispatch(); 

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [data, setData] = useState(null);
 
    const {token}=useSelector((state)=>state.AuthReducer);
    const makeRequest = useCallback(async (requestData) => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.post(`${URL}/api/order/check-coupon`, requestData,{
            headers:{
                Authorization:`Bearer ${token}`,
                'Accept':'application/json',
                'Content-Type':'application/json'
            }});
            console.log('response',response);
            if(response.status===200){
              setData(response.data);
              setSuccess(true)
              dispatch(setSuccessMessage('تم تأكيد الخصم '))
            
            }else{
              dispatch(setErrorMessage('كود غير صحيح '))
            }
      
      } catch (err) {
        setError(err);
        dispatch(setErrorMessage('حدث خطأ '))
      }
      setIsLoading(false);
    }, [token]);
  
    return { makeRequest, data, isLoading, error,success };
}

export default CheckCoupon